import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import upBlackarrow from '../assets/images/up-blackarrow.svg';
import rightArrow from '../assets/images/blackright-arrow.svg';
import config from '../config';

export default function LocationSlider(props) {
  // const startTime = new Date(props.startTime);
  // const endTime = new Date(props.endTime);
  const currentDate = new Date();

  // const start = startTime.getHours();
  // const end = endTime.getHours();
  const start = props.startTime;
  const end = props.endTime;
// console.log('parseInt(start)',parseInt(start))
  const s_s_startTime = props.s_s_startTime;
  const s_s_endTime = props.s_s_endTime;

  const current = currentDate.getHours();
// console.log('current',current)
  var locationStatus = '';

  if (parseInt(start) <= current && current < parseInt(end)) {
    locationStatus = 'open now';
  }

  if (parseInt(start) <= current && current < parseInt(end)) {
    locationStatus = 'open now';
  } else {
    locationStatus = 'closed';
  }

  if (current === end - 1) {
    locationStatus = 'closing soon';
  }

  const openMenuModal = (index) => {
    props.setShowModal(true);
    if (props.key === index) {
      props.setModalContent({
        title: props.title,
        image: props.imgsrc,
        status: locationStatus,
        time: props?.title === "One Island East" ? `M-F: ${start} - ${end}${parseInt(end) > 12 ? "pm" : "am"}` : `M-S: ${start} - ${end}${parseInt(end) > 12 ? "pm" : "am"}`,
        // time1: `S+S: ${s_s_startTime % 12} - ${s_s_endTime % 12}${s_s_endTime > 12 ? "pm" : "am"}`,
        menuId: props.menuId,
        moreLink: props.moreLink
      });
    }
  }

  const formatTime = (time) => {
    if (!time) return ""; // Handle undefined or missing values
  
    const [hour, minute] = time.split(":").map(Number);
  
    // Check if hour and minute are valid numbers
    if (isNaN(hour) || isNaN(minute)) {
      return ""; // Return empty string if the time is invalid
    }
  
    const period = hour >= 12 ? "PM" : "AM"; // Determine AM/PM
    const formattedHour = hour % 12 || 12; // Convert 0 to 12 for midnight
    return `${formattedHour}:${minute.toString().padStart(2, "0")} ${period}`;
  };
  
  return (
    <>
      <div className='location-community-slider'>
        <div className="location-community-slider-items">
          {!props.hideImage && (<img src={props.imgsrc} alt="menu" />)}
          <div className="location-community-slider-items-desc">
          <NavLink className="more-icon" exact to={props.moreLink}><h4>{props.title}<img src={rightArrow} alt="arrow-icon" /></h4></NavLink>
            <div className="status-sec">
              {/* <span className={`menu-status ${(locationStatus === 'closed' || locationStatus === 'closing soon') ? 'closing-soon' : 'open'}`}>
                {locationStatus}
              </span> */}
              <span className="menu-time">
                {`${formatTime(start)} - ${formatTime(end)}`}
              </span>
            </div>
            <div className="location-community-slider-items-desc-botm">
              <span onClick={() => openMenuModal(props.key)}>MENU</span>
              <NavLink className="more-icon" exact to={props.moreLink}>MORE<img src={upBlackarrow} alt="arrow-icon" /></NavLink>
            </div>
          </div>
        </div>
      </div>

    </>
  )
}

const LocationMenu = (props) => {
  // const startTime = new Date(props.startTime);
  // const endTime = new Date(props.endTime);
  const currentDate = new Date();

  // const start = startTime.getHours();
  // const end = endTime.getHours();
  const start = props.startTime;
  const end = props.endTime;

  // console.log("start: ", start);

  // const endSoon = parseInt(props.endTime - 1);

  const s_s_startTime = parseInt(props.s_s_startTime);
  const s_s_endTime = parseInt(props.s_s_endTime);

  const current = currentDate.getHours();

  var locationStatus = '';

  if (parseInt(start) <= current && current < parseInt(end)) {
    locationStatus = 'open now';
  }

  if (parseInt(start) <= current && current < parseInt(end)) {
    locationStatus = 'open now';
  } else {
    locationStatus = 'closed';
  }

  if (current === parseInt(end) - 1) {
    locationStatus = 'closing soon';
  }

  const openMenuModal = (index) => {
    props.setShowModal(true);
    if (props.key === index) {
      props.setModalContent({
        title: props.title,
        image: props.imgsrc,
        status: locationStatus,
        time: props?.title === "One Island East" ? `M-F: ${start} - ${end}${parseInt(end) > 12 ? "pm" : "am"}` : `M-S: ${start} - ${end}${parseInt(end) > 12 ? "pm" : "am"}`,
        // time1: `S+S: ${s_s_s tartTime % 12} - ${s_s_endTime % 12}${s_s_endTime > 12 ? "pm" : "am"}`,
        menuId: props.menuId,
        moreLink: props.moreLink
      });
    }
  }

  return (
    <>
      <div className='location-community-slider'>
        <div className="location-community-slider-items">
          {!props.hideImage && (<img src={props.imgsrc} alt="menu" className='mobile-view' />)}
          <div className="location-community-slider-items-desc">

            <h4>{props.title}</h4>
            <div className='location-both-buttons'>
              <div className="status-sec">
                {!props.hideImage && (
                  <span className={`menu-status ${(locationStatus === 'closed' || locationStatus === 'closing soon') ? 'closing-soon' : 'open'}`}>
                    {locationStatus}
                  </span>
                )}

                {!props.hideImage ?
                  <span className='menu-time'>
                    {/* <span>{`M-S: ${start % 12 === 0 ? 12 : start % 12}-`}{`${end % 12}${end > 12 ? "pm" : "am"}`}</span> */}

                    <span>{props?.title === "One Island East" ? `M-F:` : 'M-S:'}{`${(String(start).split(":")[0] % 12) === 0 ? 12 : String(start).split(":")[0] % 12 }${(String(start).split(":")[1] !== "00" ? ":" + String(start).split(":")[1] : "")}${String(start).split(":")[0] > 12 ? "pm" : "am"}`} - {`${(String(end).split(":")[0] % 12 === 0 ? 12 : String(end).split(":")[0] % 12)}${(String(end).split(":")[1] !== "00" ? ":" + String(end).split(":")[1] : "")}${String(end).split(":")[0] > 12 ? "pm" : "am"}`}</span>

                    {/* <span>{`S+S: ${s_s_startTime % 12}-`}{`${s_s_endTime % 12}${s_s_endTime > 12 ? "pm" : "am"}`}</span> */}
                  </span>
                  : (
                    <span className='menu-time'>{`${String(start).split(":")[0] % 12}${String(start).split(":")[0] > 12 ? "pm" : "am"}`}
                      <span>-</span>
                      <span>{`${String(end).split(":")[0] % 12}${String(end).split(":")[0] > 12 ? "pm" : "am"}`}</span>
                    </span>
                  )}

              </div>
              <div className="location-community-slider-items-desc-botm">
                <span onClick={() => openMenuModal(props.key)}>MENU {!props.hideImage && <img src={upBlackarrow} alt="arrow-icon" className='mobile-view' />}</span>
                <NavLink className="more-icon" exact to={props.moreLink}>MORE
                <svg width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.73528 0.257394C9.73528 0.119324 9.62335 0.00739482 9.48528 0.00739442L7.23528 0.00739429C7.09721 0.00739454 6.98528 0.119323 6.98528 0.257395C6.98528 0.395466 7.09721 0.507395 7.23528 0.507395L9.23528 0.507395L9.23528 2.50739C9.23528 2.64547 9.34721 2.75739 9.48528 2.75739C9.62335 2.75739 9.73528 2.64547 9.73528 2.50739L9.73528 0.257394ZM1.17678 8.91945L9.66206 0.434171L9.3085 0.0806179L0.823223 8.5659L1.17678 8.91945Z" fill="black"/>
                </svg>

                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  )
}
export { LocationMenu };